import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { AjaxService } from 'src/app/service/ajax.service';
import { API } from 'src/environments/environment';

@Component({
  selector: 'app-cadastro-cartorio',
  templateUrl: './cadastro-cartorio.component.html',
  styleUrls: ['./cadastro-cartorio.component.scss']
})
export class CadastroCartorioComponent implements OnInit {
  @ViewChild('formModal') formModal!: TemplateRef<any>;

  cadastroForm: FormGroup;
  cartorios: any[] = [];
  cartoriosFiltrados: any[] = [];
  cartorioSelecionado: any = null;
  modalRef!: NgbModalRef;

  // Filtros
  filtroNome: string = '';
  filtroOficial: string = '';
  filtroRepresentante: string = '';

  // Máscaras
  cnpjMask = [/\d/, /\d/, '.', /\d/, /\d/, /\d/, '.', /\d/, /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/];
  telefoneMask = ['(', /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];

  constructor(
    private fb: FormBuilder,
    private modalService: NgbModal,
    private ajaxService: AjaxService
  ) {
    this.cadastroForm = this.fb.group({
      NOME: ['', Validators.required],
      OFICIAL: ['', Validators.required],
      ENDERECO: ['', Validators.required],
      CNPJ: ['', [Validators.required, Validators.pattern(/^\d{2}\.\d{3}\.\d{3}\/\d{4}-\d{2}$/)]],
      REPRESENTANTE: ['', Validators.required],
      TELEFONE: ['', Validators.required],
      EMAIL: ['', [Validators.required, Validators.email]],
      OBSERVACAO: ['']
    });
  }

  ngOnInit(): void {
    this.carregarCartorios();
  }

  carregarCartorios(): void {
    this.ajaxService.get(API + 'Cartorio/Cartorio').subscribe({
      next: (response) => {
        if (response && response.data.length > 0) {
          this.cartorios = response.data;
          this.cartoriosFiltrados = [...this.cartorios];
        }
      },
      error: (error) => {
        console.error('Erro ao carregar cartórios:', error);
      }
    });
  }

  openModal(modal: any, isNew: boolean = false): void {
    if (isNew) {
      this.cartorioSelecionado = null;
      this.cadastroForm.reset();
    }
    this.modalRef = this.modalService.open(modal, { size: 'lg', centered: true });
  }

  editarCartorio(cartorio: any): void {
    debugger
    this.cartorioSelecionado = cartorio;
    this.cadastroForm.patchValue({
      NOME: cartorio.nome,
      OFICIAL: cartorio.oficial,
      ENDERECO: cartorio.endereco,
      CNPJ: cartorio.cnpj,
      REPRESENTANTE: cartorio.representante,
      TELEFONE: cartorio.telefone,
      EMAIL: cartorio.email,
      OBSERVACAO: cartorio.observacao
    });
  }

  onSubmit(): void {
    if (this.cadastroForm.valid) {
      const dados = this.cadastroForm.value;
      
      if (this.cartorioSelecionado) {
        // Editar
        debugger
        dados.ID_CARTORIO = this.cartorioSelecionado.iD_CARTORIO;
        this.ajaxService.put(API + 'Cartorio/Cartorio', dados).subscribe({
          next: (response) => {
            this.modalRef.close();
            this.carregarCartorios();
            this.aplicarFiltros();
          },
          error: (error) => {
            console.error('Erro ao atualizar cartório:', error);
          }
        });
      } else {
        // Novo
        this.ajaxService.post(API + 'Cartorio/Cartorio', dados).subscribe({
          next: (response) => {
            this.modalRef.close();
            this.carregarCartorios();
            this.aplicarFiltros();
          },
          error: (error) => {
            console.error('Erro ao cadastrar cartório:', error);
          }
        });
      }
    }
  }

  aplicarFiltros(): void {
    this.cartoriosFiltrados = this.cartorios.filter(cartorio => {
      const nomeMatch = !this.filtroNome || 
        cartorio.nome?.toLowerCase().includes(this.filtroNome.toLowerCase());
      const oficialMatch = !this.filtroOficial || 
        cartorio.oficial?.toLowerCase().includes(this.filtroOficial.toLowerCase());
      const representanteMatch = !this.filtroRepresentante || 
        cartorio.representante?.toLowerCase().includes(this.filtroRepresentante.toLowerCase());
      
      return nomeMatch && oficialMatch && representanteMatch;
    });
  }

  limparFiltros(): void {
    this.filtroNome = '';
    this.filtroOficial = '';
    this.filtroRepresentante = '';
    this.cartoriosFiltrados = [...this.cartorios];
  }
} 